import { render, staticRenderFns } from "./line1.vue?vue&type=template&id=1527210a&scoped=true"
import script from "./line1.vue?vue&type=script&lang=js"
export * from "./line1.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1527210a",
  null
  
)

export default component.exports